import "../formElement/FormElement.css.ts.vanilla.js";
import "../formInputElement/FormInputElement.css.ts.vanilla.js";
import "./NewsletterCard.css.ts.vanilla.js";
var c = "_6hwc520", i = "_6hwc524", h = "_6hwc521", o = "_6hwc525", v = "_6hwc526", w = "_6hwc523", _ = "_6hwc522";
export {
  c as cardBackground,
  i as formContainer,
  h as isEditMode,
  o as left,
  v as right,
  w as subtitle,
  _ as title
};
